export default __webpack_public_path__ + "static/media/728.b98a7610.png";